import * as React from 'react';

import { LegacyBox, styled } from '@gogame/components';

const OutlinedFieldWrapper = styled(LegacyBox)`
  padding: ${(props) => props.padding};
  box-sizing: border-box;
  align-self: ${(props) => props.alignSelf};
  width: ${(props) => props.width || '100%'};
`;

export const FieldWrapper = React.forwardRef(
  (
    {
      children,
      basis,
      grow,
      order,
      shrink,
      vertical,
      inline,
      padding,
      width,
      hasError,
    },
    ref
  ) => {
    return (
      <OutlinedFieldWrapper
        basis={basis}
        grow={grow}
        order={order}
        shrink={shrink}
        vertical={vertical}
        inline={inline}
        padding={padding}
        width={width}
        ref={ref}
        data-cy-has-error={hasError}
      >
        {children}
      </OutlinedFieldWrapper>
    );
  }
);
